export default {
  fr: {
    Global: {
      meta: {
        title: 'ROXHAM',
        description: 'Un récit immersif basé sur 32 histoires vécues, créé par le photographe Michel Huneault, avec Maude Thibodeau et Chantal Dumas. Une production ONF, en collaboration avec Le Devoir, Phi et Dpt.',
        twitter: 'ROXHAM, un récit immersif basé sur 32 histoires vécues, créé par le photographe Michel Huneault, avec Maude Thibodeau et Chantal Dumas. Une production @ONF, en collaboration avec @LeDevoir, @phicentre et @bonjourdpt'
      },
    }
  },
  en: {
    Global: {
      meta: {
        title: 'ROXHAM',
        description: 'An immersive experience based on 32 true stories, created by photographer Michel Huneault, with Maude Thibodeau and Chantal Dumas. A NFB production, in collaboration with Le Devoir, Phi and Dpt.',
        twitter: 'ROXHAM, an immersive experience based on 32 true stories, created by photographer Michel Huneault, with Maude Thibodeau and Chantal Dumas. A @theNFB production, in collaboration with @LeDevoir, @phicentre et @bonjourdpt'
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/commons/lang/GlobalLang.js